import React from "react";
import { Icon } from "../icons";

/** Shared pieces of the list views (workspaces, people, conversations): the filter toolbar and its predicates. */

export function Toolbar({ children, shown, total, noun, active, onClear }) {
  return (
    <div className="aa-card" style={{ padding: "14px 16px" }}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "flex-end" }}>{children}</div>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 12, paddingTop: 12, borderTop: "1px solid var(--aa-border)", fontSize: 12, color: "var(--aa-muted)" }}>
        <Icon name="filter" size={13} />
        <span className="aa-num">
          {shown == null ? "…" : total != null && total !== shown ? (
            <>
              <b style={{ color: "var(--aa-ink)" }}>{shown.toLocaleString()}</b> of {total.toLocaleString()} {noun}
            </>
          ) : (
            <>
              <b style={{ color: "var(--aa-ink)" }}>{shown.toLocaleString()}</b> {noun}
            </>
          )}
        </span>
        {active > 0 && (
          <button type="button" className="aa-link" style={{ fontSize: 12 }} onClick={onClear}>
            Clear {active} filter{active === 1 ? "" : "s"}
          </button>
        )}
      </div>
    </div>
  );
}

export const MIN_REQUESTS = [["", "Any"], ["2", "2+"], ["5", "5+"], ["20", "20+"], ["100", "100+"]];
export const SUCCESS_BANDS = [["", "Any"], ["bad", "Below 70%"], ["watch", "70–90%"], ["good", "90%+"], ["none", "Nothing finished"]];
export const ACTIVE_SINCE = [["", "Any time"], ["1", "Last 24 hours"], ["7", "Last 7 days"]];

export const inBand = (rate, band) =>
  !band || (band === "none" ? rate == null : rate != null && (band === "bad" ? rate < 0.7 : band === "watch" ? rate >= 0.7 && rate < 0.9 : rate >= 0.9));
export const activeWithin = (date, days) => !days || (date && Date.now() - new Date(date).getTime() <= Number(days) * 86_400_000);
export const matches = (q, ...texts) => !q || texts.some((t) => String(t ?? "").toLowerCase().includes(q.toLowerCase()));
export const countActive = (filters) => Object.values(filters).filter((v) => (typeof v === "object" && v ? Object.values(v).some(Boolean) : Boolean(v))).length;
